
import { ForecastModel } from "@/lib/types";
import { DataSource } from "@/components/data-tables/DataTables";

export const createDataSource = (model: ForecastModel): DataSource => ({
  type: "forecast",
  id: model.id,
  name: model.name,
  sourceType: "forecast",
  data: model
});
